function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { grey2, black, zIndexHigherThanPlatform } from "@churchofjesuschrist/eden-style-constants";
import hex2rgba from "hex2rgba";
import styled from "styled-components";
import Portal from "./components/Portal";
/**
 * The @supports is meant for progressive enhancement of the backdrop-filter.
 */

const Scrim = styled.div.withConfig({
  componentId: "sc-isi5s2-0"
})(["@supports (backdrop-filter:blur(2px)){backdrop-filter:blur(2px);}background:", ";visibility:", ";top:0;right:0;bottom:0;left:0;position:fixed;pointer-events:auto;transition:background-color 100ms linear,backdrop-filter 100ms linear;z-index:", ";"], _ref => {
  let {
    maskTypeIsLight,
    active
  } = _ref;
  return maskTypeIsLight ? active ? hex2rgba(grey2, 0.85) : hex2rgba(grey2, 0) : active ? hex2rgba(black, 0.85) : hex2rgba(black, 0);
}, props => props.active ? "visible" : "hidden", zIndexHigherThanPlatform);

const PlatformMask = _ref2 => {
  let {
    active,
    children,
    type = "normal",
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Scrim, _extends({}, props, {
    active: active,
    maskTypeIsLight: type === "media" ? false : true,
    "data-testid": "scrim"
  }), children));
};

PlatformMask.propTypes = {
  /** Content on top of masked overlay */
  children: PropTypes.node.isRequired,

  /** Whether masked overlay is displayed */
  active: PropTypes.bool,

  /** Receives a string to determine light or dark scrim "media" = dark "normal" = light */
  type: PropTypes.oneOf(["media", "normal"])
};
export default PlatformMask;